import React from 'react';
import {MENUS} from '../../../../../../utils/query_utils';
import ColumnName from '../../../../../common/column_name';
import DatasetAttributeInput from '../dataset_attribute_input';
import DatasetAttributeComponent from '../dataset_attribute';

export default class ColumnAttribute extends DatasetAttributeComponent {
    canRemove() {
        return this.props.attribute.column;
    }

    renderAttribute() {
        const {attribute, datasetOpen} = this.props;
        if (!datasetOpen && this.isLast()) {
            return;
        }
        return (
            <>
                <DatasetAttributeInput
                    attribute={attribute}
                    propName="column"
                    valueProp="getFullName"
                    placeholder="+ Add Column"
                    focusedPlaceholder="Search for column name"
                    display={attribute.column ? <ColumnName column={attribute.column} /> : null}
                    menu={MENUS.COLUMN}
                    ref={(el) => { this.columnInput = el; }}
                />
            </>
        )
    }
}
